import { QueryClient } from '@tanstack/react-query';
import { httpBatchLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
import superjson from 'superjson';

import { apiFetch } from './api-fetch';
import { getApiBaseUrl } from './api-url';
import { getCurrentVesselId } from './vessel-context';

import type { AppRouter } from '@navioworks/api';

export const trpc: ReturnType<typeof createTRPCReact<AppRouter>> = createTRPCReact<AppRouter>();

const getApiUrl = () => `${getApiBaseUrl()}/trpc/naviofit`;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    },
    mutations: {
      retry: 1,
    },
  },
});

let supabaseGetToken: (() => Promise<string | null>) | null = null;

export function setSupabaseTokenGetter(getter: () => Promise<string | null>) {
  supabaseGetToken = getter;
}

export const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: getApiUrl(),
      fetch: apiFetch,
      // @ts-expect-error - tRPC v11 link typing does not pick up the router transformer config.
      transformer: superjson,
      async headers() {
        try {
          const baseHeaders: Record<string, string> = {};
          if (supabaseGetToken) {
            const accessToken = await supabaseGetToken();
            if (accessToken) {
              baseHeaders['authorization'] = `Bearer ${accessToken}`;
            }
          }
          const vesselId = getCurrentVesselId();
          if (vesselId) {
            baseHeaders['x-vessel-id'] = vesselId;
          }
          return baseHeaders;
        } catch (error) {
          console.error('Error in tRPC headers:', error);
          return {};
        }
      },
    }),
  ],
});

export const TRPCProvider = trpc.Provider;
